import React, { createContext, useCallback, useContext, useEffect, useRef, useState, } from 'react';
import { getCountriesWithPhone, } from '../../Services/methods/countriesWithPhone';
const CountriesWithPhoneContext = createContext({
    countries: undefined,
    loadCountries: () => { },
});
export const CountriesWithPhoneProvider = ({ children }) => {
    const [countriesWithPhone, setCountriesWithPhone] = useState();
    const isLoadingRef = useRef(false);
    const loadCountries = useCallback(() => {
        if (countriesWithPhone || isLoadingRef.current)
            return;
        isLoadingRef.current = true;
        getCountriesWithPhone().then((res) => {
            setCountriesWithPhone(res);
            isLoadingRef.current = false;
        });
    }, [countriesWithPhone]);
    return (<CountriesWithPhoneContext.Provider value={{ countries: countriesWithPhone, loadCountries }}>
      {children}
    </CountriesWithPhoneContext.Provider>);
};
export function useCountriesWithPhone() {
    const { countries, loadCountries } = useContext(CountriesWithPhoneContext);
    useEffect(() => {
        loadCountries();
    }, [loadCountries]);
    return countries;
}
